import { doesSpecialApply, getSpecialIdsForTagLabel } from '@iheartjane/menu';

// eslint-disable-next-line no-restricted-imports
import type { StoreSpecial } from '@jane/shared/models';
import type { MaterializedMenuProduct } from '@jane/shared/types';
import { doesSpecialApply as doesSpecialApplyOld } from '@jane/shared/util';

export const findSpecialForProduct = (
  menuProduct: MaterializedMenuProduct,
  specials: StoreSpecial[] = [],
  bundleTag?: boolean
): StoreSpecial | undefined =>
  specials
    .filter(Boolean)
    .find((special) =>
      bundleTag
        ? doesSpecialApply(
            getSpecialIdsForTagLabel(menuProduct),
            special.id,
            special.special_type
          )
        : doesSpecialApplyOld('default', special, menuProduct)
    );
